// React
import { useRef, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import AuthService from "../../Context/auth.service";

//Ionic
import { IonInput, IonItem, IonLabel } from "@ionic/react";

//CSS
import "./Register.css";

// Variables

function LoginComponent(props) {
  const userRef = useRef();
  const errRef = useRef();

  // Login Data
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  // Messages
  const [errMsg, setErrMsg] = useState("");
  // Check Login State
  const [loggedIn, setLoggedIn] = useState(false);
  // Redirect
  const history = useHistory();

  useEffect(() => {
    userRef.current.focus();
  }, []);

  useEffect(() => {
    setErrMsg("");
  }, [username, password]);

  useEffect(() => {
    if (AuthService.getCurrentUser()) {
      if (AuthService.getCurrentUser().token) {
        setLoggedIn(true);
      }
    }
  
  }, [loggedIn]);

  function handleLogin(e) {
    e.preventDefault();

    AuthService.login(username, password).then((response) => {
      if (response.token) {

        history.push("/home");

        setUsername("");
        setPassword("");
      } else {
        setErrMsg(response);
      }
    });
  }

  function handleLogout(e) {
    e.preventDefault();

    AuthService.logout();
  }

  return (
    <div>
      <p
        ref={errRef}
        className={errMsg ? "errmsg" : "offscreen"}
        aria-live="assertive"
      >
        {errMsg}
      </p>

      <form onSubmit={handleLogin}>
        <IonItem>
          <IonLabel for="username">Username</IonLabel>
          <IonInput
            type="text"
            id="username"
            ref={userRef}
            autoComplete="off"
            onIonChange={(e) => setUsername(e.target.value)}
            value={username}
            required
          ></IonInput>
        </IonItem>

        <IonItem>
          <IonLabel for="password">Passwort</IonLabel>
          <IonInput
            type="password"
            id="password"
            onIonChange={(e) => setPassword(e.target.value)}
            value={password}
            required
          ></IonInput>
        </IonItem>

        <button>Anmelden</button>
        {/*  <p>
              Noch nicht registriert?
              <br />
              <span className="line">
                <Link to="/register">Zur Registrierung</Link>
              </span>
            </p> */}
      </form>
      <button onClick={handleLogout}>Logout</button>
    </div>
  );
}

export default LoginComponent;
